import service from './request'

/**
 * 获取菜单分组列表
 */
export const getListMenuGroup = data => {
    return service({
	      showLoading: false,//调用预加载
        url: '/platform/menuGroup/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 菜单分组信息添加
 */
export const addInfoMenuGroup = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/menuGroup/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 菜单分组信息修改
 */
 export const updateInfoMenuGroup = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/menuGroup/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 菜单分组信息删除
 */
 export const delInfoMenuGroup = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/menuGroup/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 菜单分组信息排序
 */
export const changePositionMenuGroup = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menuGroup/changePosition',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 子菜单列表
 */
export const getListByGroupSubmenu = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menu/getListByGroup',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 子菜单添加
 */
 export const addInfoSubmenu = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menu/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 子菜单修改
 */
 export const updateInfoSubmenu = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menu/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 子菜单删除
 */
 export const delInfoSubmenu = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menu/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 子菜单排序
 */
 export const changePositionSubmenu = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menu/changePosition',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 菜单参数列表
 */
 export const menuParamGetList = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menuParam/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 菜单参添加
 */
 export const menuParamAddInfo = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menuParam/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 菜单参修改
 */
 export const menuParamUpdateInfo = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menuParam/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 菜单参删除
 */
 export const menuParamDelInfo = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menuParam/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 子菜单权限发布
 */
 export const publishMenu = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/menu/publish',
        method: 'post',
        data
    })
}

/**
 * 左侧菜单列表
 */
export const getLoginInfo = params => {
    return service({
      url: "/user/getLoginInfo",
      method: 'post',
      params
    });
}


// WEBPACK FOOTER //
// ./src/http/MenuManagement.js